import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['overlay', 'body', 'container']

  connect () {
    this.toggleBodyScroll()

    enter(this.overlayTarget)
    enter(this.bodyTarget)
  }

  close () {
    this.toggleBodyScroll()

    leave(this.overlayTarget)
    leave(this.bodyTarget).then(() => {
      this.element.remove()
    })
  }

  closeOnClickOutside ({ target }) {
    if (this.containerTarget === target) this.close()
  }

  toggleBodyScroll () {
    document.body.classList.toggle('overflow-hidden')
  }
}
